













































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Datasource } from '../services/datasource';
import { Lov } from '../models/lov';

@Component
export default class EditLov extends Vue {
  @Prop() private msg!: string

  source:Datasource

  // Data Placeholder
  values:Lov[] = []
  pendingValue:Lov = new Lov()
  editing:number = -1
  editingValue:Lov|null = null

  get types() {
    return Lov.Types
  }

  constructor() {
    super()
    this.source = Datasource.shared
  }

  mounted() {
    this.source.lov()
      .then((lov:Lov[]) => {
        this.values = lov
        console.log(lov);
      })
      .catch(console.error)
  }

  isEditing(row:number) {
    return row == this.editing;
  }

  beginEdit(editRow:number) {
    this.editingValue = Lov.clone(this.values[editRow])
    this.editing = editRow
  }

  commitCurrentCreate() {
    // fool-check
    if (!this.pendingValue.isValid) { 
      console.log('Value is not valid.', this.pendingValue)
      return
    }

    const pendingValue = this.pendingValue
    this.source.createLov(pendingValue)
      .then((result:number) => {
        console.log('Result from Creation API', result)
        pendingValue.id = result
        this.values.push(pendingValue)
        this.pendingValue = new Lov()
      })
      .catch(console.error)
  }

  commitCurrentEdit() {
    this.source.updateLov(this.values[this.editing])
      .then(() => {
        this.editingValue = null
        this.editing = -1
      })
      .catch(console.error)
  }

  deleteRow(row:number) {
    // sanity check
    if (!(row < this.values.length)) {
      return
    }
    const valueToDelete = this.values[row]
    if (!valueToDelete.id) {
      return
    }

    this.source.deleteLov(valueToDelete.id)
      .then(() => {
        this.values.splice(row, 1)
      })
  }

  cancelCurrentEdit(newRow:number) {
    // Cancel current editing row
    if (this.editing >= 0 && this.editingValue != null) {
      this.values[this.editing] = this.editingValue
      this.editingValue = null
    }
    if (newRow >= 0) {
      this.beginEdit(newRow)
    }
    else {
      this.editing = newRow
    }
  }
}
